import {ContactShadows, Html, OrbitControls, PresentationControls} from "@react-three/drei";
import {Canvas, useThree} from "@react-three/fiber";
import React from "react";
import {STLExporter} from "three/examples/jsm/exporters/STLExporter";
import * as THREE from "three";
import {wallThickness} from "../../providers/consts";

export interface ElementConfig {
    geometry: THREE.ExtrudeGeometry;
    height: number;
}

export interface ProductViewerProps {
    elements: ElementConfig[];
    bottom: THREE.ExtrudeGeometry | null;
    color: string;
}

const scale = 0.015;
const heightScale = 0.012

const SaveButton = () => {
    const three = useThree();

    const save = () => {
        const exporter = new STLExporter();
        three.scene.receiveShadow = false;
        const stlString = exporter.parse(three.scene);
        const blob = new Blob([stlString], {type: 'text/plain'});

        const a = document.createElement('a');
        a.download = 'my-file.stl';
        a.href = URL.createObjectURL(blob);
        a.addEventListener('click', (e) => {
            setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
        });
        a.click();
    };

    return (
        <Html>
            <button onClick={save}>Export to STL</button>
        </Html>
    )
}

const ProductViewer = (props: ProductViewerProps) => {
    let currentHeight = -150;
    // const material = new THREE.MeshPhongMaterial({
    //     color: props.color,
    //     flatShading: true,
    // });

    const material = new THREE.MeshStandardMaterial({
        color: props.color,
        metalness: 0.5
    })

    // const material = new THREE.MeshLambertMaterial({ color: props.color })

    return (

        <Canvas style={{height: '600px', backgroundColor: '#2d4967', borderRadius: 12, marginBottom: 16, marginTop: 16}} camera={{fov: 75, aspect: 1}}>
            <SaveButton/>
            <ambientLight intensity={0.5}/>
            <spotLight position={[10, 10, 10]} angle={0.15} penumbra={1} shadow-mapSize={2048} castShadow/>
            <PresentationControls
                global
                config={{mass: 2, tension: 500}}
                snap={{mass: 10, tension: 500}}
                rotation={[2, 0, 0]}
                polar={[-Math.PI / 3, Math.PI / 3]}
                azimuth={[-Math.PI / 1.4, Math.PI / 2]}>
                <group scale={[scale, scale, heightScale]}>
                    {props.elements.map((e, index) => {
                        currentHeight += e.height;
                        return (
                            <mesh
                                key={index}
                                position={[0, 0, (currentHeight - e.height)]}
                                geometry={e.geometry}
                                material={material}
                                castShadow
                                receiveShadow
                            />
                        )
                    })}
                    {props.bottom && (<mesh
                        position={[0, 0, (currentHeight - wallThickness)]}
                        geometry={props.bottom}
                        material={material}
                        castShadow
                        receiveShadow
                    />)}
                </group>
            </PresentationControls>
            {/*<ContactShadows position={[0, -2, 0]} opacity={0.75} scale={10} blur={3} far={4}/>*/}
            <OrbitControls zoomSpeed={0.2} rotateSpeed={0.01}/>
        </Canvas>
    )
}

export default ProductViewer;